<template>
  <div class="supporters grid-11" @focusout="hide">
    <div id="supportersInput" class="row align-center">
      <input class="input" @click="forceAppear" v-model="search" @keyup.enter="supporter()" placeholder="Nome"
        required />
      <Button @click="supporter" :loader="loader"><i v-if="!loader" class="fa fa-search" title="Pesquisar" /></Button>
    </div>
    <ul :class="css" class="sfl" v-if="show" :style="sty">
      <li v-for="(item, i) in filterList" :key="i + 'op'" @click="choice(item)">
        {{ getName(item) }}
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    name: [String, Array],
    css: String,
    required: [String, Boolean],
    placeholder: String
  },
  data() {
    return {
      search: "",
      show: false,
      sty: "",
      list: [],
      loader: false
    };
  },
  methods: {
    ...mapActions("admin", ["SUPPORTERS_LIST"]),
    forceAppear(e) {
      this.search = ''
      this.show = true;
      this.sty = `top:${e.pageY + 30}px`;
      this.$forceUpdate();
    },
    getName(item) {
      if (Array.isArray(this.name)) {
        let name = "";
        this.name.map((n, i) => (name += i == 0 ? item[n] : " - " + item[n]));
        return name;
      }
      return item[this.name];
    },
    choice(item) {
      this.search = this.getName(item);
      this.show = false;
      this.$emit("value", item);
    },
    hide() {
      var se = this;
      setTimeout(() => (se.show = false), 300);
    },
    async supporter() {
      if (this.search.length > 0) {
        this.loader = true;
        await this.SUPPORTERS_LIST({ nome: this.search }).then(({ data }) => this.list = data || [])
        this.loader = false
      } else {
        alert("O campo nome não deve ser vazio.")
      }
    }
  },
  computed: {
    filterList() {
      if (this.search) {
        const search = this.search.toLowerCase();
        return this.list.filter((item) => {
          for (let field in item) {
            if (item[field] && item[field].toString().toLowerCase().includes(search))
              return item;
          }
        });
      } else return this.list;
    },
  },
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.supporters
  button
    min-width: 40px
    height: 50px
    margin-left: -40px
    background: none
    box-shadow: none
    i
      font-size: 20px
      &:hover
        color: $purple
  ul
    box-shadow: $shadow
    position: absolute
    background: $white
    max-height: 50%
    border-radius: 23px
    overflow: auto
    li
      padding: 21px 33px
      border-bottom: 1px solid #eee
      cursor: pointer
      &:hover
        background: $purple
        font-weight: bold
        color: $white
</style>
